import React, { Component } from 'react'
import { BarLoader } from 'react-spinners'

import '../scss/Error.scss'

class Error extends Component {

  constructor (props) {
    super(props)
  }

  componentDidMount () {
    if (this.props.environment !== 'development-local' && this.props.environment !== 'development') {
      setTimeout(() => {
        window.location = this.props.fallbackRedirect
      }, 3000)
    }
  }

  render () {
    return (
        <div className="Error">
          <p>
            Something's gone wrong and our team has been notified.
          </p>
          <p>
            Hold on a second — we'll work around the issue and deliver the research.
          </p>
          {this.props.environment === 'development-local' || this.props.environment === 'development' &&
              <div>
                <div>
                  <strong>Development Mode</strong>
                </div>
                <div>
                  This mode does not automatically redirect so you can debug the error.
                </div>
                <div>
                  <a href={this.props.fallbackRedirect}>Redirect Now</a>
                </div>
              </div>
          }
          <div className="LoadingBar">
            <BarLoader color="#eeeeef" loading={true} />
          </div>

          <div className="Error-footer">
            <div className="Error-footer-item">
              <strong>Release</strong>
              <br />
              <code>{this.props.release}</code>
            </div>
            <div className="Error-footer-item">
              <strong>Error</strong>
              <br />
              {this.props.error}
            </div>
            <div className="Error-footer-item">
              <strong>Error ID</strong>
              <br />
              <code>{this.props.eventId}</code>
            </div>
          </div>
        </div>
    )
  }
}

export default Error
